import firebase from 'firebase/app';
import 'firebase/database';

const OrganizationException = message => {
  this.message = message;
  this.name = 'OrganizationException';
};

export default getState => {
  const rootPath = getState().getIn(['organizations', 'selected', 'root'], undefined);

  if (!rootPath) {
    throw new OrganizationException('Root path is undefined');
  }

  return firebase.database().ref(rootPath);
};



// WEBPACK FOOTER //
// ./src/utilities/organizationRoot.js